var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSiteDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    fill: "#bcc5ea",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:#020301;}\r\n\t.st8{clip-path:url(#SVGID_2_);}\r\n\t.st9{clip-path:url(#SVGID_4_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210,
    y1: 0,
    x2: 210,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 220,
    y1: 0,
    x2: 220,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270,
    y1: 0,
    x2: 270,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280,
    y1: 0,
    x2: 280,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290,
    y1: 0,
    x2: 290,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 10,
    x2: 320,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 20,
    x2: 320,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 30,
    x2: 320,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 40,
    x2: 320,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 50,
    x2: 320,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 70,
    x2: 320,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 80,
    x2: 320,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 90,
    x2: 320,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110,
    x2: 320,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 130,
    x2: 320,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 140,
    x2: 320,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 150,
    x2: 320,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 160,
    x2: 320,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 170,
    x2: 320,
    y2: 170
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 180,
    x2: 320,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 190,
    x2: 320,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 200,
    x2: 320,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 210,
    x2: 320,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 220,
    x2: 320,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 230,
    x2: 320,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 240,
    x2: 320,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 320,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 260,
    x2: 320,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 270,
    x2: 320,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 280,
    x2: 320,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 290,
    x2: 320,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 300,
    x2: 320,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 310,
    x2: 320,
    y2: 310
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.5,105.9H65.8c-1.7,0-3,1.3-3,3v16.8c0,1.7,1.3,3,3,3h16.8c1.7,0,3-1.3,3-3v-16.8C85.5,107.2,84.2,105.9,82.5,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,151.4H65.8c-1.7,0-3,1.3-3,3v16.8c0,1.7,1.3,3,3,3h16.8c1.7,0,3-1.3,3-3v-16.8C85.5,152.7,84.2,151.4,82.5,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,105.9H111.2c-1.7,0-3,1.3-3,3v16.8c0,1.7,1.3,3,3,3h143.5c1.7,0,3-1.3,3-3v-16.8 C257.8,107.2,256.4,105.9,254.8,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,151.4H111.2c-1.7,0-3,1.3-3,3v16.8c0,1.7,1.3,3,3,3h143.5c1.7,0,3-1.3,3-3v-16.8 C257.8,152.7,256.4,151.4,254.8,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8,40H28.2c-9.9,0-18,8.1-18,18v164c0,9.9,8.1,18,18,18h72v40h120v-40h71.5c9.9,0,18-8.1,18-18V58 C309.8,48.1,301.7,40,291.8,40z M290.8,212.6c0,4.6-3.8,8.4-8.4,8.4H37.7c-4.6,0-8.4-3.8-8.4-8.4V67.4c0-4.6,3.8-8.4,8.4-8.4 h244.7c4.6,0,8.4,3.8,8.4,8.4V212.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteDocument);
export default __webpack_public_path__ + "static/media/Icon_Site_Document.bae71f240c8cee495088e18b527cedb7.svg";
export { ForwardRef as ReactComponent };